/**
 * 契約API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 使用場所情報
 */
export interface Szma102aResponseEmpposUserMstEmpposMstInfo {
    /**
     * 使用お客さま番号：数字
     */
    logicDeviceNo?: string;
    /**
     * サービス種別コード：英数字<br>　コード変換マスターテーブル.画面項目ID「C008410」のユーザコードを設定
     */
    srvClsfyCode?: string;
    /**
     * サービス種別コード名称：全半角混在
     */
    srvClsfyCodeAname?: string;
    /**
     * 外部接続番号：英数字
     */
    extCnnctNo?: string;
    /**
     * 住所コード：英数字
     */
    addrcd?: string;
    /**
     * 郵便番号：数字
     */
    postno?: string;
    /**
     * 都道府県名称：全角
     */
    pfcAname?: string;
    /**
     * 都道府県カナ名称：全角（カナ）
     */
    pfcKanaAname?: string;
    /**
     * 市区郡町村名称：全角
     */
    mptAname?: string;
    /**
     * 市区郡町村カナ名称：全角（カナ）
     */
    mptKanaAname?: string;
    /**
     * 町域名称：全角
     */
    twareaAname?: string;
    /**
     * 町域カナ名称：全角（カナ）
     */
    twareaKanaAname?: string;
    /**
     * 大字丁目名称：全角
     */
    oazaAname?: string;
    /**
     * 大字丁目カナ名称：全角（カナ）
     */
    oazaKanaAname?: string;
    /**
     * 番地：数字
     */
    banti?: string;
    /**
     * 番地区分：英数字<br>　コード変換マスターテーブル.画面項目ID「C008870」のユーザコードを設定
     */
    bantiDiv?: string;
    /**
     * 番地区分名称：全半角混在
     */
    bantiDivAname?: string;
    /**
     * 番地区分カナ名称：全半角混在
     */
    bantiDivKanaAname?: string;
    /**
     * 号：数字
     */
    gou?: string;
    /**
     * 号区分：英数字<br>　コード変換マスターテーブル.画面項目ID「C008880」のユーザコードを設定
     */
    gouDiv?: string;
    /**
     * 号区分名称：全半角混在
     */
    gouDivAname?: string;
    /**
     * 号区分カナ名称：全半角混在
     */
    gouDivKanaAname?: string;
    /**
     * 分筆号：英数字
     */
    bunptGou?: string;
    /**
     * 住宅・棟号漢字名：全角
     */
    supadrAname?: string;
    /**
     * 住宅・棟号カナ名：全角（カナ/数字/英字/スペース/記号）
     */
    supadrKananm?: string;
    /**
     * 屋号・業種・目標（漢字）：全角
     */
    yagouAname?: string;
    /**
     * 屋号・業種・目標（カナ）：全角（カナ/数字/英字/スペース/記号）
     */
    yagouKananm?: string;
    /**
     * 表示住所漢字：全角
     */
    addrAnameF?: string;
    /**
     * 表示住所カナ：全角
     */
    addrKanaAnameF?: string;
}

